module.exports = __webpack_public_path__ + "img/login.22a31a31.svg";